import React, { memo } from 'react'
import { Path } from 'react-native-svg'

import { IconBase } from '../IconBase'
import { IconProps } from '../IconProps'
import { themed } from '../themed'

const Icon = (props) => {
  const { color = 'black', size = 24, ...otherProps } = props
  return (
    <IconBase
      width={size}
      height={size}
      viewBox="0 0 34 35"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <Path
        d="M17 34.668c9.389 0 17-7.611 17-17s-7.611-17-17-17-17 7.611-17 17 7.611 17 17 17Z"
        fill="#FFC10E"
      />
      <Path
        d="M25.587 26.071a11.986 11.986 0 0 0-17.224.05c-.602.622.346 1.573.949.95 4.223-4.365 11.075-4.391 15.326-.051.607.62 1.555-.33.95-.949ZM11.832 14.508a2.67 2.67 0 1 0 0-5.34 2.67 2.67 0 0 0 0 5.34ZM21.928 14.474a2.67 2.67 0 1 0 0-5.34 2.67 2.67 0 0 0 0 5.34Z"
        fill="#333"
      />
    </IconBase>
  )
}

Icon.displayName = 'IconFaceSad'

export const IconFaceSad = memo<IconProps>(themed(Icon))
